import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
    wrapper = _ref.wrapper,
    children = _ref.children;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: condition ? wrapper(children) : children
  });
};
export default ConditionalWrapper;